import React, { useState } from 'react';

import MarkUpCategoryForm from './MarkUpCategoryForm';

import Button from 'CommonComponents/Button';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function MarkUpCategorySaveModal(props) {
    const [categoryIsUpdated, setCategoryIsUpdated] = useState(false);
    const [request, setRequest] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);

    const cleanStates = () => {
        setRequest(false);
        setRequestFailed(false);
        setCategoryIsUpdated(false);
    };

    const internalCloseHandler = () => {
        cleanStates();
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        cleanStates();
        props.successHandler();
    };

    const close = () => {
        internalCloseHandler();
        props.modalElement.hide();
    };

    return (
        <Modal id={props.id} modal={props.modal}>
            <ModalHeader title={props.action === 'update' ? $t('Edit Mark Up Category') : $t('Create Mark Up Category')} close={close}></ModalHeader>
            <div className="tw-rounded-b">
                {((props.action === 'update' && Object.keys(props.category).length) || props.action === 'create') && (
                    <div className="modal__form-container">
                        <div className={!categoryIsUpdated && !requestFailed ? 'modal__form-container' : 'hidden'}>
                            <MarkUpCategoryForm
                                category={props.category}
                                updateUrl={props.updateUrl}
                                internalCloseHandler={internalCloseHandler}
                                setCategoryIsUpdated={setCategoryIsUpdated}
                                request={request}
                                action={props.action}
                            />
                        </div>
                        <div className={categoryIsUpdated ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                            <label className="modal__msg modal__text-color">
                                {props.action === 'update' ? $t('[{{category}}] updated', { category: props.category.name }) : $t('Category created')}
                            </label>
                        </div>
                        <div className={requestFailed ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                            <label className="modal__msg modal__error-text-color">
                                {props.action === 'update'
                                    ? $t('[{{category}}] could not be updated', { category: props.category.name })
                                    : $t('Category could not be created')}
                            </label>
                        </div>

                        {(categoryIsUpdated || requestFailed) && (
                            <div className="modal__footer">
                                <Button variant="secondary" onClick={internalSuccessHandler}>
                                    {$t('Close')}
                                </Button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </Modal>
    );
}
